let host = "https://store.drbingo.com/";

const FacebookLoginPlugin = {
    install(Vue, options = {}) {
        // Load Facebook SDK dynamically
        const loadFacebookSDK = () => {
            return new Promise((resolve) => {
                if (document.getElementById('facebook-jssdk')) {
                    resolve(window.FB);
                    return;
                }

                const script = document.createElement('script');
                script.id = 'facebook-jssdk';
                script.src = 'https://connect.facebook.net/en_US/sdk.js';
                script.onload = () => resolve(window.FB);
                document.body.appendChild(script);
            });
        };

        // Initialize Facebook SDK
        const initFacebookSDK = async (appId) => {
            const FB = await loadFacebookSDK();
            FB.init({
                appId: appId,
                cookie: true,
                xfbml: true,
                version: 'v17.0', // Update to the SDK version you need
            });
        };

        // Handle Facebook login
        const loginWithFacebook = (scope = 'public_profile,email') => {
        //const loginWithFacebook = (scope = '') => {
            return new Promise((resolve, reject) => {
                window.FB.login(
                    (response) => {
                        if (response.authResponse) {
                            resolve(response.authResponse);
                        } else {
                            reject(new Error('User cancelled login or did not fully authorize.'));
                        }
                    },
                    { scope }
                );
            });
        };

        // Fetch user data
        const fetchUserData = () => {
            return new Promise((resolve, reject) => {
                window.FB.api('/me', { fields: 'id,name,email,picture' }, (response) => {
                    if (!response || response.error) {
                        reject(response.error);
                    } else {
                        resolve(response);
                    }
                });
            });
        };

        // Provide methods to Vue components
        Vue.prototype.$facebookLogin = {
            init: initFacebookSDK,
            login: loginWithFacebook,
            getUserData: fetchUserData,
        };
    },
};

export default FacebookLoginPlugin;

/*const facebookLogin = (onSuccess, onFailed) => {
    getFacebookLoginStatus(function(data) {
        let expiresIn = data["authResponse"]["expiresIn"];
        onSuccess && onSuccess({
            "access_token": data["authResponse"]["accessToken"],
            "expireTime": Math.round(new Date().valueOf() / 1000) + expiresIn,
            "login_type": "facebook",
            "platform": "com"
        });
    }, 0, onFailed);
}

const getFacebookLoginStatus = (onSuccess, repeat = 0, onFailed) => {
    if (repeat >= 3) {
        onFailed && onFailed();
        return;
    }
    try {
        FB.getLoginStatus(function(data) {
            if (data["status"] === "connected") {
                if (onSuccess) onSuccess(data);
            } else {
                FB.login(function(onSuccess, onFailed, response) {
                    if (response["status"] === "connected") {
                        getFacebookLoginStatus(onSuccess, 0, onFailed);
                    }
                }.bind(this, onSuccess, onFailed));
            }
        });
    } catch (e) {
        setTimeout(getFacebookLoginStatus.bind(this, callback, ++repeat, onFailed), 100);
    }
}

export default {
    facebookLogin: facebookLogin
}*/



// WEBPACK FOOTER //
// ./src/network/facebook.js